<template>
    <div class="container pt-2">
        <PageTitle icon="fa fa-address-card" main="Meus Jobs" sub="Cadastrar, alterar ou deletar jobs feitos por você" />
        <b-form enctype="multipart/form-data">
            <input id="job-id" type="hidden" v-model="job.id" />
            <b-card no-body>
                <b-tabs v-model="tabIndex" card>
                    <b-tab title="Dados" active>
                        <b-card-text>
                            <div class="row">
                                <div class="col-md-4">
                                    <b-form-group label="Número do Processo:" label-for="job-numero">
                                        <b-form-input id="job-numero" type="text"
                                            v-model="job.numero"
                                            placeholder="Informe o numero do job."
                                            v-mask="'###.####.###.###'"
                                            :class="{ 'inputError': $v.job.numero.$error }"
                                            @keydown.tab="$v.job.numero.$touch"/>
                                        <span class="error" v-if="!$v.job.numero.required && $v.job.numero.$error">Campo Obrigatório!</span>
                                        <span class="error" v-if="!$v.job.numero.minLength && $v.job.numero.$error">Precisa ter no mínimo 3 letras!</span>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group label="Categoria:" label-for="job-categoria">
                                        <b-form-select id="job-categoria" :options="categorias"
                                            v-model="job.categoria"
                                            placeholder="Informe categoria."
                                            :class="{ 'inputError': $v.job.categoria.$error }"
                                            @keydown.tab="$v.job.categoria.$touch"
                                            @change="loadSubcategorias"/>
                                        <span class="error" v-if="!$v.job.categoria.required && $v.job.categoria.$error">Campo Obrigatório!</span>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group label="Subcategoria:" label-for="job-subcategoria">
                                        <b-form-select id="job-subcategoria" :options="subcategorias"
                                            v-model="job.subcategoria"
                                            placeholder="Informe subcategoria."
                                            :class="{ 'inputError': $v.job.subcategoria.$error }"
                                            @keydown.tab="$v.job.subcategoria.$touch"
                                            @change="loadTiposervicos"/>
                                        <span class="error" v-if="!$v.job.subcategoria.required && $v.job.subcategoria.$error">Campo Obrigatório!</span>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-12">
                                    <label for="job-descricao">Descrição do Serviço:</label>
                                    <b-form-textarea id="job-descricao" placeholder="Escreva aqui..."
                                        rows="3" v-model="job.descricao"
                                        :class="{ 'inputError': $v.job.descricao.$error }"
                                        @keydown.tab="$v.job.descricao.$touch">
                                    </b-form-textarea>
                                    <span class="error" v-if="!$v.job.descricao.required && $v.job.descricao.$error">Campo Obrigatório!</span>
                                    <span class="error" v-if="!$v.job.descricao.minLength && $v.job.descricao.$error">Precisa ter no mínimo 3 caracteres!</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group label="Serviço:" label-for="job-tipoServico">
                                        <b-form-select id="job-tipoServico" :options="tipoServicos"
                                            v-model="job.id_tiposervico"
                                            placeholder="Informe o Serviço."
                                            :class="{ 'inputError': $v.job.id_tiposervico.$error }"
                                            @keydown.tab="$v.job.id_tiposervico.$touch"/>
                                        <span class="error" v-if="!$v.job.id_tiposervico.required && $v.job.id_tiposervico.$error">Campo Obrigatório!</span>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Data da Publicação:" label-for="job-dataPublicacao">
                                        <b-form-input id="job-dataPublicacao" type="date"
                                            v-model="job.dataPublicacao"
                                            :class="{ 'inputError': $v.job.dataPublicacao.$error }"
                                            @keydown.tab="$v.job.dataPublicacao.$touch"/>
                                        <span class="error" v-if="!$v.job.dataPublicacao.required && $v.job.dataPublicacao.$error">Campo Obrigatório!</span>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <b-form-group label="UF:" label-for="job-uf">
                                        <b-form-select id="job-uf" :options="ufs" v-model="job.uf"
                                        :class="{ 'inputError': $v.job.uf.$error }"
                                        @keydown.tab="$v.job.uf.$touch"/>
                                        <span class="error" v-if="!$v.job.uf.required && $v.job.uf.$error">Campo Obrigatório!</span>
                                    </b-form-group>
                                </div>
                                <div class="col-md-3">
                                    <b-form-group label="Cidade:" label-for="job-cidade">
                                        <b-form-input id="job-cidade" type="text"
                                            v-model="job.cidade"
                                            placeholder="Informe o cidade do job."
                                            :class="{ 'inputError': $v.job.cidade.$error }"
                                            @keydown.tab="$v.job.cidade.$touch"/>
                                        <span class="error" v-if="!$v.job.cidade.required && $v.job.cidade.$error">Campo Obrigatório!</span>
                                    </b-form-group>
                                </div>
                                <div class="col-md-3">
                                    <b-form-group label="Vara:" label-for="job-vara">
                                        <b-form-input id="job-vara" type="text"
                                            v-model="job.vara"
                                            placeholder="Informe o vara do job."
                                            :class="{ 'inputError': $v.job.vara.$error }"
                                            @keydown.tab="$v.job.vara.$touch"/>
                                        <span class="error" v-if="!$v.job.vara.required && $v.job.vara.$error">Campo Obrigatório!</span>
                                    </b-form-group>
                                </div>
                                <div class="col-md-3">
                                    <b-form-group label="segredoJustica:" label-for="job-segredoJustica">
                                        <b-form-select id="job-segredoJustica" :options="segredoJusticas" v-model="job.segredoJustica"
                                        :class="{ 'inputError': $v.job.segredoJustica.$error }"
                                        @keydown.tab="$v.job.segredoJustica.$touch"/>
                                        <span class="error" v-if="!$v.job.segredoJustica.required && $v.job.segredoJustica.$error">Campo Obrigatório!</span>
                                    </b-form-group>
                                </div>
                            </div>
                            <b-button variant="outline-info" class="float-right mb-3" @click="tabIndex++">Próximo</b-button>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Arquivos">
                        <b-card-text> 
                            <div class="row">
                                <b-button variant="success" class="float-right mb-3 btn-sm ml-2" style="width: 30px; height: 30px;" @click="arquivoIndex < 5 ? arquivoIndex++ : ''" v-if="arquivoIndex!==5">+</b-button>
                                <b-button variant="danger" class="float-right mb-3 btn-sm ml-2" style="width: 30px; height: 30px;" @click="arquivoIndex > 0 ? arquivoIndex-- : ''" v-if="arquivoIndex!==0">-</b-button>
                            </div>
                            <hr/>
                            <div class="row justify-content-md-center" v-if="arquivoIndex>=1">
                                <div class="col-md-8">
                                    <b-form-group label="Arquivo 01:" label-for="filejob-arquivo01">
                                        <b-form-file
                                            id="filejob-arquivo01"
                                            placeholder="Escolha o arquivo ou arraste aqui..."
                                            drop-placeholder="Arraste aqui..."></b-form-file>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row justify-content-md-center mb-3" v-if="arquivoIndex>=1">
                                <div class="col-md-8">
                                    <div v-if="filejob.arquivo01">Arquivo Selecionado: {{ filejob.arquivo01 ? filejob.arquivo01 : '' }}</div>
                                </div>
                            </div>
                            <div class="row justify-content-md-center" v-if="arquivoIndex>=1">
                                <div class="col-md-8">
                                    <b-form-group label="Descrição 01:" label-for="filejob-descricao01">
                                        <b-form-input id="filejob-descricao01" type="text"
                                            v-model="filejob.descricao01"
                                            placeholder="Informe o numero do job."/>
                                    </b-form-group>
                                </div>
                            </div>
                            <hr v-if="arquivoIndex>=1"/>
                            <div class="row justify-content-md-center" v-if="arquivoIndex>=2">
                                <div class="col-md-8">
                                    <b-form-group label="Arquivo 02:" label-for="filejob-arquivo02">
                                        <b-form-file
                                            id="filejob-arquivo02"
                                            placeholder="Escolha o arquivo ou arraste aqui..."
                                            drop-placeholder="Arraste aqui..."></b-form-file>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row justify-content-md-center mb-3" v-if="arquivoIndex>=2">
                                <div class="col-md-8">
                                    <div v-if="filejob.arquivo02">Arquivo Selecionado: {{ filejob.arquivo02 ? filejob.arquivo02 : '' }}</div>
                                </div>
                            </div>
                            <div class="row justify-content-md-center" v-if="arquivoIndex>=2">
                                <div class="col-md-8">
                                    <b-form-group label="Descrição 02:" label-for="filejob-descricao02">
                                        <b-form-input id="filejob-descricao02" type="text"
                                            v-model="filejob.descricao02"
                                            placeholder="Informe o numero do job."/>
                                    </b-form-group>
                                </div>
                            </div>
                            <hr v-if="arquivoIndex>=2"/>
                            <div class="row justify-content-md-center" v-if="arquivoIndex>=3">
                                <div class="col-md-8">
                                    <b-form-group label="Arquivo 03:" label-for="filejob-arquivo03">
                                        <b-form-file
                                            id="filejob-arquivo03"
                                            placeholder="Escolha o arquivo ou arraste aqui..."
                                            drop-placeholder="Arraste aqui..."></b-form-file>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row justify-content-md-center mb-3" v-if="arquivoIndex>=3">
                                <div class="col-md-8">
                                    <div v-if="filejob.arquivo03">Arquivo Selecionado: {{ filejob.arquivo03 ? filejob.arquivo03 : '' }}</div>
                                </div>
                            </div>
                            <div class="row justify-content-md-center" v-if="arquivoIndex>=3">
                                <div class="col-md-8">
                                    <b-form-group label="Descrição 03:" label-for="filejob-descricao03">
                                        <b-form-input id="filejob-descricao03" type="text"
                                            v-model="filejob.descricao03"
                                            placeholder="Informe o numero do job."/>
                                    </b-form-group>
                                </div>
                            </div>
                            <hr v-if="arquivoIndex>=3"/>
                            <div class="row justify-content-md-center" v-if="arquivoIndex>=4">
                                <div class="col-md-8">
                                    <b-form-group label="Arquivo 04:" label-for="filejob-arquivo04">
                                        <b-form-file
                                            id="filejob-arquivo04"
                                            placeholder="Escolha o arquivo ou arraste aqui..."
                                            drop-placeholder="Arraste aqui..."></b-form-file>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row justify-content-md-center mb-3" v-if="arquivoIndex>=4">
                                <div class="col-md-8">
                                    <div v-if="filejob.arquivo04">Arquivo Selecionado: {{ filejob.arquivo04 ? filejob.arquivo04 : '' }}</div>
                                </div>
                            </div>
                            <div class="row justify-content-md-center" v-if="arquivoIndex>=4">
                                <div class="col-md-8">
                                    <b-form-group label="Descrição 04:" label-for="filejob-descricao04">
                                        <b-form-input id="filejob-descricao04" type="text"
                                            v-model="filejob.descricao04"
                                            placeholder="Informe o numero do job."/>
                                    </b-form-group>
                                </div>
                            </div>
                            <hr v-if="arquivoIndex>=4"/>
                            <div class="row justify-content-md-center" v-if="arquivoIndex>=5">
                                <div class="col-md-8">
                                    <b-form-group label="Arquivo 05:" label-for="filejob-arquivo05">
                                        <b-form-file
                                            id="filejob-arquivo05"
                                            placeholder="Escolha o arquivo ou arraste aqui..."
                                            drop-placeholder="Arraste aqui..."></b-form-file>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row justify-content-md-center mb-3" v-if="arquivoIndex>=5">
                                <div class="col-md-8">
                                    <div v-if="filejob.arquivo05">Arquivo Selecionado: {{ filejob.arquivo05 ? filejob.arquivo05 : '' }}</div>
                                </div>
                            </div>
                            <div class="row justify-content-md-center" v-if="arquivoIndex>=5">
                                <div class="col-md-8">
                                    <b-form-group label="Descrição 05:" label-for="filejob-descricao05">
                                        <b-form-input id="filejob-descricao05" type="text"
                                            v-model="filejob.descricao05"
                                            placeholder="Informe o numero do job."/>
                                    </b-form-group>
                                </div>
                            </div>
                            <hr v-if="arquivoIndex>=5"/>
                            <b-button variant="outline-danger" class="float-right ml-2 mb-3" @click="reset">Cancelar</b-button>
                            <b-button variant="outline-success" class="float-right mb-3" @click="save">Salvar</b-button>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(servico)="data">
                    {{ data.item.categoria_titulo }}->{{ data.item.subcategoria_titulo }}->{{ data.item.id_tiposervico_titulo }}
                </template>
                <template v-slot:cell(prazo)="data">
                    {{ data.item.id_tiposervico_prazo }} dias
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadJob(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-jobs" 
                class="text-center table table-sm" 
                :items="jobs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(servico)="data">
                    {{ data.item.categoria_titulo }}->{{ data.item.subcategoria_titulo }}->{{ data.item.id_tiposervico_titulo }}
                </template>
                <template v-slot:cell(prazo)="data">
                    {{ data.item.id_tiposervico_prazo }} dias
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadJob(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-jobs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'jobs',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            nivel: '',
            tabIndex: 0,
            arquivoIndex: 0,
            segredoJusticas: [
                { value: 'Sim', text: 'Sim' },
                { value: 'Nao', text: 'Não' }
            ],
            ufs: [
                { value: 'AC', text: 'Acre' },
                { value: 'AL', text: 'Alagoas' },
                { value: 'AP', text: 'Amapa' },
                { value: 'AM', text: 'Amazonas' },
                { value: 'BA', text: 'Bahia' },
                { value: 'CE', text: 'Ceará' },
                { value: 'DF', text: 'Distrito Federal' },
                { value: 'ES', text: 'Espirito Santo' },
                { value: 'GO', text: 'Goiás' },
                { value: 'MA', text: 'Maranhão' },
                { value: 'MT', text: 'Mato Grosso' },
                { value: 'MS', text: 'Mato Grosso do Sul' },
                { value: 'MG', text: 'Minas Gerais' },
                { value: 'PA', text: 'Para' },
                { value: 'PB', text: 'Paraíba' },
                { value: 'PR', text: 'Paraná' },
                { value: 'PE', text: 'Pernambuco' },
                { value: 'PI', text: 'Piauí' },
                { value: 'RJ', text: 'Rio de Janeiro' },
                { value: 'RN', text: 'Rio Grande do Norte' },
                { value: 'RS', text: 'Rio Grande do Sul' },
                { value: 'RO', text: 'Rondônia' },
                { value: 'RR', text: 'Roraima' },
                { value: 'SC', text: 'Santa Catarina' },
                { value: 'SP', text: 'São Paulo' },
                { value: 'SE', text: 'Sergipe' },
                { value: 'TO', text: 'Tocantins' }
            ],
            job: {},
            jobs: [],
            filejob: {},
            filejobs: [],
            categoria: {},
            categorias: [],
            subcategoria: {},
            subcategorias: [],
            tipoServico: {},
            tipoServicos: [],
            quemRecebeu: '',
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            fields: [
                { key: 'numero', label: 'Número', sortable: true },
                { key: 'servico', label: 'Serviço', sortable: true },
                { key: 'dataPublicacao', label: 'Data de Publicação', sortable: true, formatter: 'formatData' },
                { key: 'prazo', label: 'Prazo', sortable: true },
                { key: 'status', label: 'Status', sortable: true },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' }  }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    validations: {
        job: {
            numero: {
                required,
                minLength: minLength(4)
            },
            categoria: {
                required
            },
            subcategoria: {
                required
            },
            descricao: {
                required,
                minLength: minLength(10)
            },
            quemPublicou: {
                required
            },
            id_tiposervico: {
                required
            },
            dataPublicacao: {
                required
            },
            cidade: {
                required
            },
            uf: {
                required
            },
            vara: {
                required
            },
            segredoJustica: {
                required
            }     
        }
    },
    computed: {
        ...mapState(['user']),
        rows() {
            return this.jobs.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        loadCategorias() {
            const url = `${baseApiUrl}/backend/SELECT/categorias.php`
            axios.get(url).then(res => {
                this.categorias = res.data.map(categoria => {
                    return { ...categoria, value: categoria.id, text: categoria.titulo }
                })
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        loadSubcategorias() {
            const id = this.job.categoria
            // const id = document.getElementById("jobs-categoria").value
            const url = `${baseApiUrl}/backend/GENERAL/subcategoriasByCategoria.php?categoria=${id}`
            axios.get(url).then(res => {
                this.subcategorias = res.data.map(subcategoria => {
                    return { ...subcategoria, value: subcategoria.id, text: subcategoria.titulo }
                })
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        loadTiposervicos() {
            const id = this.job.subcategoria
            // const id = document.getElementById("jobs-categoria").value
            const url = `${baseApiUrl}/backend/GENERAL/tipoServicosBySubcategoria.php?subcategoria=${id}`
            axios.get(url).then(res => {
                this.tipoServicos = res.data.map(tipoServico => {
                    return { ...tipoServico, value: tipoServico.id, text: tipoServico.titulo }
                })
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        loadJobs() {
            const url = `${baseApiUrl}/backend/SELECT/jobs.php?colaborador=${this.quemRecebeu}`
            axios.get(url).then(res => {
                this.jobs = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            })
        },
        reset() {
            this.job = {}
            this.filejob = {}
            this.loadJobs()
            this.$v.job.$reset()
            this.tabIndex--
            this.arquivoIndex = 0
        },
        save() {
            this.$v.job.$touch()
            if(!this.$v.job.$error){
                const method = this.job.id ? 'put' : 'post'
                const id = this.job.id ? `?id=${this.job.id}` : ''
                if(method === 'post'){
                    this.job.status = 'AGUARDANDO ACEITE'
                    this.job.quemRecebeu = ''
                    this.job.dataPostagem = new Date()
                    this.job.dataAceite = ''
                    this.job.dataFinalizacao = ''
                    this.job.quemPublicou = this.quemRecebeu

                    axios[method](`${baseApiUrl}/backend/INSERT/jobs.php`, this.job)
                        .then(() => {

                            this.filejob.job = this.job.numero
                            if(this.arquivoIndex === 1) {
                                this.filejob.arquivo01 = document.getElementById('filejob-arquivo01').value
                            } else if(this.arquivoIndex === 2) {
                                this.filejob.arquivo01 = document.getElementById('filejob-arquivo01').value
                                this.filejob.arquivo02 = document.getElementById('filejob-arquivo02').value
                            } else if(this.arquivoIndex === 3) {
                                this.filejob.arquivo01 = document.getElementById('filejob-arquivo01').value
                                this.filejob.arquivo02 = document.getElementById('filejob-arquivo02').value
                                this.filejob.arquivo03 = document.getElementById('filejob-arquivo03').value
                            } else if(this.arquivoIndex === 4) {
                                this.filejob.arquivo01 = document.getElementById('filejob-arquivo01').value
                                this.filejob.arquivo02 = document.getElementById('filejob-arquivo02').value
                                this.filejob.arquivo03 = document.getElementById('filejob-arquivo03').value
                                this.filejob.arquivo04 = document.getElementById('filejob-arquivo04').value
                            } else if(this.arquivoIndex === 5) {
                                this.filejob.arquivo01 = document.getElementById('filejob-arquivo01').value
                                this.filejob.arquivo02 = document.getElementById('filejob-arquivo02').value
                                this.filejob.arquivo03 = document.getElementById('filejob-arquivo03').value
                                this.filejob.arquivo04 = document.getElementById('filejob-arquivo04').value
                                this.filejob.arquivo05 = document.getElementById('filejob-arquivo05').value
                            }
                            axios[method](`${baseApiUrl}/backend/INSERT/arquivo_job.php?job=${this.filejob.job}`, this.filejob)
                            .then(() => {
                                
                                this.$toasted.global.defaultSuccess({ message : 'Arquivos do Job inserido com sucesso!' })
                                this.reset()
                            })
                            .catch(
                                (e) => {
                                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                            })

                            this.$toasted.global.defaultSuccess({ message : 'Job inserido com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                } else {
                    axios[method](`${baseApiUrl}/backend/UPDATE/jobs.php${id}`, this.job)
                        .then(() => {

                            this.filejob.job = this.job.id
                            if(this.arquivoIndex === 1) {
                                this.filejob.arquivo01 = document.getElementById('filejob-arquivo01').value
                            } else if(this.arquivoIndex === 2) {
                                this.filejob.arquivo01 = document.getElementById('filejob-arquivo01').value
                                this.filejob.arquivo02 = document.getElementById('filejob-arquivo02').value
                            } else if(this.arquivoIndex === 3) {
                                this.filejob.arquivo01 = document.getElementById('filejob-arquivo01').value
                                this.filejob.arquivo02 = document.getElementById('filejob-arquivo02').value
                                this.filejob.arquivo03 = document.getElementById('filejob-arquivo03').value
                            } else if(this.arquivoIndex === 4) {
                                this.filejob.arquivo01 = document.getElementById('filejob-arquivo01').value
                                this.filejob.arquivo02 = document.getElementById('filejob-arquivo02').value
                                this.filejob.arquivo03 = document.getElementById('filejob-arquivo03').value
                                this.filejob.arquivo04 = document.getElementById('filejob-arquivo04').value
                            } else if(this.arquivoIndex === 5) {
                                this.filejob.arquivo01 = document.getElementById('filejob-arquivo01').value
                                this.filejob.arquivo02 = document.getElementById('filejob-arquivo02').value
                                this.filejob.arquivo03 = document.getElementById('filejob-arquivo03').value
                                this.filejob.arquivo04 = document.getElementById('filejob-arquivo04').value
                                this.filejob.arquivo05 = document.getElementById('filejob-arquivo05').value
                            }
                            axios[method](`${baseApiUrl}/backend/UPDATE/arquivo_job.php?job=${this.filejob.job}`, this.filejob)
                            .then(() => {
                                this.$toasted.global.defaultSuccess({ message : 'Arquivos do Job alterado com sucesso!' })
                                this.reset()
                            })
                            .catch(
                                (e) => {
                                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                            })

                            this.$toasted.global.defaultSuccess({ message : 'Job alterado com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                }
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(job) {
            const sure = confirm("Deseja realmente excluir o Job?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/DELETE/jobs.php`
                axios.delete(url, { data: job })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Job excluído com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadJob(job) {
            this.job = { ...job }
            
            const url = `${baseApiUrl}/backend/SELECT/arquivo_job.php?job=${this.job.id}`
            axios.get(url).then(res => {
                this.filejob = res.data[0]
                const arr1 = this.filejob.arquivo01.split('/')
                if(arr1[4] !== "") {
                    this.arquivoIndex = 1
                    const arr2 = this.filejob.arquivo02.split('/')
                    if(arr2[4] !== "") {
                        this.arquivoIndex = 2
                        const arr3 = this.filejob.arquivo03.split('/')
                        if(arr3[4] !== "") {
                            this.arquivoIndex = 3
                            const arr4 = this.filejob.arquivo04.split('/')
                            if(arr4[4] !== "") {
                                this.arquivoIndex = 4
                                const arr5 = this.filejob.arquivo05.split('/')
                                if(arr5[4] !== "") {
                                    this.arquivoIndex = 5
                                } else {
                                    this.arquivoIndex = 4
                                }
                            } else {
                                this.arquivoIndex = 3
                            }
                        } else {
                            this.arquivoIndex = 2
                        }
                    } else {
                        this.arquivoIndex = 1
                    }
                } else {
                    this.arquivoIndex = 0
                }
            })

            this.loadCategorias()
            this.loadSubcategorias()
            this.loadTiposervicos()
            // this.loadCategorias()
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel === 'prestador') {
            this.$router.push('/')
        }
        this.loadJobs()
        this.loadCategorias()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.jobs.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

#job-numero, #job-categoria, #job-subcategoria, #job-descricao, #job-colaborador, 
#job-tipoServico, #job-cidade, #job-uf, #job-vara, #job-segredoJustica, #job-dataPublicacao {
   /* border: 0; */
    outline: 0;
    border-radius: 10px;
    /* border-bottom: 1px solid #AAA; */
    background-color: rgba(255,255,255,0.4);
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border-bottom: 1px solid #f57f6c !important;
}

.text-custom {
    font-size: 0.8rem;
}
</style>